export default function dimensionsFilter(dimensions) {
  if (!dimensions) return '–';
  const unit = 'мм';
  let result = [];
  if (dimensions.hasOwnProperty('width')) {
    result.push(dimensions.width);
  }
  if (dimensions.hasOwnProperty('height')) {
    result.push(dimensions.height);
  }
  if (dimensions.hasOwnProperty('depth') && dimensions.depth !== 0) {
    result.push(dimensions.depth);
  }
  return result.join(' x ') + ` ${unit}`;
}
